import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

// Auth
export const createAuthSession = (session_id) => client.post('/auth/session', { session_id }).then((r) => r.data);
export const registerUser = (data) => client.post('/auth/register', data).then((r) => r.data);
export const loginUser = (data) => client.post('/auth/login', data).then((r) => r.data);
export const getMe = () => client.get('/auth/me').then((r) => r.data);
export const logout = () => client.post('/auth/logout').then((r) => r.data);
export const getMyActivity = () => client.get('/auth/me/activity').then((r) => r.data);

// Forum
export const getCategories = () => client.get('/forum/categories').then((r) => r.data);
export const getPosts = (params = {}) => client.get('/forum/posts', { params }).then((r) => r.data);
export const getPost = (id) => client.get(`/forum/posts/${id}`).then((r) => r.data);
export const createPost = (data) => client.post('/forum/posts', data).then((r) => r.data);
export const addReply = (id, data) => client.post(`/forum/posts/${id}/replies`, data).then((r) => r.data);
export const likePost = (id) => client.post(`/forum/posts/${id}/like`).then((r) => r.data);

// Blog
export const getBlogPosts = () => client.get('/blog/posts').then((r) => r.data);
export const getBlogPost = (slug) => client.get(`/blog/posts/${slug}`).then((r) => r.data);

// Contact
export const sendContact = (data) => client.post('/contact', data).then((r) => r.data);

// Cohort payments
export const cohortCheckout = (data) => client.post('/cohort/checkout', data).then((r) => r.data);
export const paymentStatus = (session_id) => client.get(`/payments/status/${session_id}`).then((r) => r.data);

// Digest
export const digestPreview = () => client.get('/digest/preview').then((r) => r.data);
export const subscribeDigest = (data) => client.post('/digest/subscribe', data).then((r) => r.data);
export const sendMeDigest = (data) => client.post('/digest/send-me', data).then((r) => r.data);

// Admin
export const adminSummary = () => client.get('/admin/summary').then((r) => r.data);
export const adminMembers = () => client.get('/admin/members').then((r) => r.data);
export const adminSubscribers = () => client.get('/admin/subscribers').then((r) => r.data);
export const adminEnrollments = () => client.get('/admin/enrollments').then((r) => r.data);
export const adminContacts = () => client.get('/admin/contacts').then((r) => r.data);

// Live
export const getLive = () => client.get('/live').then((r) => r.data);
export const adminGetLive = () => client.get('/admin/live').then((r) => r.data);
export const adminSetLive = (data) => client.post('/admin/live', data).then((r) => r.data);

// Analytics
export const trackView = (data) => client.post('/track', data).then((r) => r.data);
export const adminAnalytics = (days = 30) => client.get('/admin/analytics', { params: { days } }).then((r) => r.data);

// Blog engagement (comments + reactions)
export const getBlogEngagement = (slug) => client.get(`/blog/posts/${slug}/engagement`).then((r) => r.data);
export const reactBlog = (slug, type) => client.post(`/blog/posts/${slug}/react`, { type }).then((r) => r.data);
export const addBlogComment = (slug, content) => client.post(`/blog/posts/${slug}/comments`, { content }).then((r) => r.data);
export const deleteBlogComment = (slug, id) => client.delete(`/blog/posts/${slug}/comments/${id}`).then((r) => r.data);

// Admin — blog / content
export const adminListBlog = () => client.get('/admin/blog').then((r) => r.data);
export const adminGetBlog = (id) => client.get(`/admin/blog/${id}`).then((r) => r.data);
export const adminCreateBlog = (data) => client.post('/admin/blog', data).then((r) => r.data);
export const adminUpdateBlog = (id, data) => client.put(`/admin/blog/${id}`, data).then((r) => r.data);
export const adminDeleteBlog = (id) => client.delete(`/admin/blog/${id}`).then((r) => r.data);
export const adminUpload = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return client
    .post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => ({ ...r.data, fullUrl: BACKEND_URL + r.data.url }));
};

export default client;
